.containerHome {
    padding-inline: 20px;
    padding-bottom: 56px;
    @media only screen and (min-width: 768px) {
        padding-inline: 0px;
    }
}

// A column already supplies the surrounding spacing and editorial heading.
:global([data-embed-home-column='1']) {
    padding-inline: 0 !important;
    padding-bottom: 0 !important;

    :global([data-widget-header]) {
        display: none !important;
    }
}
